import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Frontend Development"
                    description="Responsive, User-Centric Interfaces for Seamless Experiences
We specialize in building intuitive, visually appealing, and responsive websites using the latest frontend technologies like HTML, CSS, JavaScript, React, and Flutter. Whether you're creating a sleek e-commerce platform, a corporate website, or a web application, we craft interfaces that engage users and provide a seamless experience across all devices and screen sizes."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Backend Development"
                    description="Robust Server-Side Logic for Scalable Applications
Our backend development team is skilled in building powerful server-side architectures that handle complex business logic, database interactions, and API integrations. We develop custom solutions to support your application’s unique needs, ensuring fast, secure, and reliable performance."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="System Architecture"
                    description="Scalable & Flexible Architectures for Future Growth
We design system architectures that are built to evolve with your business. Whether it’s a microservices approach for flexibility, a monolithic design for simplicity, or a serverless architecture for scalability, we tailor solutions that meet your performance, security, and scalability needs. Our architects ensure that the infrastructure is robust, maintainable, and ready for future expansion."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Performance & Scalability"
                    description="Optimizing Websites for Speed and Reliability
A slow website or application can drive users away. We ensure your system is optimized for performance under high loads with AWS, Google Cloud, Kubernetes, and Docker. Our team implements load balancing, caching, and autoscaling to ensure your website or app remains fast, reliable, and efficient, no matter how much traffic it handles."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Code Quality & Principles"
                    description="Building Maintainable and Sustainable Code for the Long Term
We adhere to best practices such as SOLID principles, Design Patterns, and Clean Architecture to ensure your code is scalable, maintainable, and sustainable over time. By writing clean, modular code, we reduce technical debt and create systems that are easier to update and extend."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
